// Autogenerated file
export const logistTaskKanbanStagesEnum = {
    Expired: "Expired",
    Today: "Today",
    Tomorrow: "Tomorrow",
    DayAfterTomorrow: "DayAfterTomorrow",
    Later: "Later",
};
export const logistTaskKanbanStages = [
    { label: "Просроченные", value: "Expired" },
    { label: "Сегодня", value: "Today" },
    { label: "Завтра", value: "Tomorrow" },
    { label: "Послезавтра", value: "DayAfterTomorrow" },
    { label: "Позже", value: "Later" },
];
